import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap } from 'rxjs/operators';
import { Tokens } from './tokens';
import { TokenStoreService } from './token-store.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private loggedUser: string;

  constructor(private http: HttpClient, private tokenStore: TokenStoreService) {}

  refreshToken() 
  {
  	 
  	 console.log("---------------- refreshToken -------------");
  	 
    return this.http.post<any>('/api/v1/refreshPasura', {'refreshToken': this.getRefreshToken() }).pipe(
    	tap((tokens: Tokens) => 
    	{
      	this.storeTokens(tokens);
    	}));
  }

  getJwtToken() 
  {
  	 return this.tokenStore.getJwtToken(); 
  }

  
  public getRefreshToken() 
  {
    return this.tokenStore.getRefreshToken();
  }

  private storeJwtToken(jwt: string) {
    this.tokenStore.setJwtToken(jwt);
  }

  private storeTokens(tokens: Tokens) {
  	 console.log("storeTokens -> " +JSON.stringify(tokens));
    this.tokenStore.setJwtToken(tokens.jwt);
    this.tokenStore.setRefreshToken(tokens.refreshToken);
  }

  private removeTokens() {
    this.tokenStore.clearJwtToken();
    this.tokenStore.clearRefreshToken();
  }
}
